<template>
  <div :id="domUid" class="alert error tiny reveal" role="error-information">
    <p>Hiba: {{message}}</p>
  </div>
</template>

<script>
/* global Foundation */
import $ from 'jquery'
export default {
  name: 'error-reveal',
  props: ['error'],
  data () {
    return {
    }
  },
  computed: {
    domUid () {
      return 'error-reveal-' + this._uid
    },
    message () {
      return this.error ? this.error.message : ''
    }
  },
  watch: {
    error: 'onErrorChanged'
  },
  mounted: function () {
  },
  methods: {
    onErrorChanged (error) {
      if (error) {
        this.show()
      } else {
        this.hide()
      }
    },
    show () {
      if (!this.revealElement) {
        this.revealElement = new Foundation.Reveal($(this.$el), {})
      }
      $('#' + this.domUid).foundation('open')
    },
    hide () {
      if (this.revealElement) {
        $('#' + this.domUid).foundation('close')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
</style>



// WEBPACK FOOTER //
// Reveal.vue?5c92c3dc